var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m18.81836 11.29376c1.89111-1.01086 3.18164-3.0036 3.18164-5.29376 0-3.30859-2.69141-6-6-6s-6 2.69141-6 6c0 2.29016 1.29053 4.2829 3.18164 5.29376-1.73456.35761-3.38916 1.03662-4.87164 2.01624 2.79999.51001 5.44 1.70001 7.69 3.45001 2.25-1.75 4.89001-2.94 7.69-3.45001-1.48248-.97962-3.13708-1.65863-4.87164-2.01624z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.33301 18.8335h-2.33301c-.55273 0-1 .44775-1 1v3.33301c0 .55225.44727 1 1 1h2.333c1.43265-.00001 2.667-1.24001 2.667-2.66651 0-1.47021-1.19629-2.6665-2.66699-2.6665z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 23.1665v-3.333c0-.55225-.44727-1-1-1h-2.33301c-1.47068 0-2.66696 1.19625-2.66699 2.66644-.00003 1.44193 1.23486 2.66656 2.66699 2.66657h2.33301c.55273-.00001 1-.44776 1-1.00001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23 23.16998v-3.34003c0-1.64996 1.34998-3 3-3h2v-.82995c0-.54999-.45001-1-1-1-.87 0-1.75.07001-2.62.20996-2.711.44714-5.24518 1.59802-7.38 3.31812v13.33081c.34589-.11987.6756-.30096.96997-.54889 2.51001-2.13001 5.72003-3.31 9.03003-3.31.54999 0 1-.45001 1-1v-.83002h-2c-1.65002 0-3-1.34997-3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 15c-.54999 0-1 .45001-1 1v.82996h2c1.65002 0 3 1.35004 3 3v3.34003c0 1.65002-1.34998 3-3 3h-2v.83001c0 .54999.45001 1 1 1 3.31 0 6.52002 1.17999 9.03003 3.31.29437.24792.62408.42901.96997.54889v-13.33081c-2.13483-1.72009-4.66901-2.87097-7.38-3.31812-.87-.13995-1.75-.20996-2.62-.20996z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.f5c24674de9b0abee151394a854af33b.svg";
export { ForwardRef as ReactComponent };